import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmModel } from 'app/models/film';
import { ContributorModel } from 'app/models/contributor';
import { ContributorUniversity } from 'app/models/contributoruniversity';
import { FilmService } from 'app/services/film.service';
import { ContributorService } from 'app/services/contributor.service';
import { empty } from 'rxjs/Observer';
import 'rxjs/add/operator/switchMap';


@Component({
  moduleId: module.id,
  selector: 'site-aboutPage',
  templateUrl: './aboutPage.component.html',
  styleUrls: ['./aboutPage.component.css']
})
export class AboutPage {

  constructor(private contributorService:ContributorService)
  {
  }

  leadCriticList: ContributorModel;
  videoContributorsList: ContributorModel;
  filmCriticsList: ContributorModel;
  additionalContributorsList: ContributorModel;
  softwareteamList: ContributorModel;

  ngOnInit(): void{
    this.getContributors("Lead Film Critic").subscribe(c =>{
      this.leadCriticList = c;
      this.leadCriticList.startDate = new Date(this.leadCriticList[0].startDate);
    });

    this.getContributors("Video Contributor").subscribe(v =>{
      this.videoContributorsList = v;
      this.videoContributorsList.startDate = new Date(this.videoContributorsList.startDate);
    });

    this.getContributors("Film Critic").subscribe(v =>{
      this.filmCriticsList = v;
      this.filmCriticsList.startDate = new Date(this.filmCriticsList.startDate);
    });

    this.getContributors("Additional Contributor").subscribe(v =>{
      this.additionalContributorsList = v;
      this.additionalContributorsList.startDate = new Date(this.additionalContributorsList.startDate);
    });

    this.getContributors("Software Team").subscribe(v =>{
      this.softwareteamList = v;
      this.softwareteamList.startDate = new Date(this.softwareteamList.startDate);
    });

    this.getContributors("Project Manager").subscribe(v =>{
      this.softwareteamList = v;
      this.softwareteamList.startDate = new Date(this.softwareteamList.startDate);
    });
  }

  private getContributors(role:string): Observable<ContributorModel>
  {
    return this.contributorService.getContributorList(role).map((v,i)=>v);
  }

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/aboutPage/aboutPage.component.ts